<template>
  <div class="signup-component full-height">
    <el-row class="full-height flex-center">
      <el-col :span="15" style="max-width: 500px;">
        <el-card class="signup-card">
          <div class="center-block">
            <el-row :gutter="10">
              <el-col :span="24">
                <h1 class>
                  <svg
                    v-if="isZeenow"
                    width="48"
                    height="66"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 52 52"
                  >
                    <path
                      class="st0"
                      d="M43.9 35.97c-.01-1.58-.05-3.17-.1-4.75-.06-1.58-.13-3.17-.22-4.75-.02-.39-.05-.8-.06-1.2a7.9 7.9 0 0 0-.12-1.09c-.12-.72-.34-1.42-.65-2.06-.62-1.29-1.64-2.36-2.88-2.86-.63-.25-1.25-.36-1.96-.33L26 18.86h-.01l-11.92.04c-.71-.03-1.33.08-1.96.33-1.24.5-2.26 1.57-2.88 2.85-.31.64-.53 1.34-.66 2.06-.07.36-.1.72-.12 1.09-.01.4-.05.81-.07 1.2-.09 1.58-.17 3.17-.23 4.75s-.1 3.17-.11 4.75c0 1.09 0 2.17.05 3.25.84 1.67 1.92 3.2 3.19 4.55l-.01 6.71c.01.57.4 1.1 1.01 1.12h3.13v-3.5c0-.21.17-.39.39-.39h.13c.21 0 .39.17.39.39v3.5h4.14v-3.5c0-.21.17-.39.39-.39h.13c.21 0 .39.17.39.39v3.5h4.14v-3.5c0-.21.17-.39.39-.39h.13c.21 0 .39.17.39.39v3.5h4.14v-3.5c0-.21.17-.39.39-.39h.13c.21 0 .39.17.39.39v3.5h4.14v-3.5c0-.21.18-.39.39-.39h.13c.21 0 .38.17.38.39v3.5h3.03c.66-.02 1.13-.46 1.12-1.11l.01-6.71a19.46 19.46 0 0 0 3.19-4.54c.03-1.05.04-2.15.04-3.23m-27.83 2.06c-2.98 0-5.4-3.38-5.39-7.55 0-4.17 2.43-7.54 5.41-7.54s5.4 3.38 5.4 7.55c-.02 4.16-2.44 7.54-5.42 7.54m9.87 5.51h-1.92l1.92-3.02 1.91 3.03-1.91-.01zm9.92-5.5c-2.98 0-5.4-3.38-5.39-7.55 0-4.17 2.43-7.54 5.41-7.54s5.4 3.38 5.4 7.55c-.02 4.17-2.44 7.55-5.42 7.54"
                    />
                    <path
                      class="st0"
                      d="M49.46 17.54c1.3-1.68 1.89-5 1.33-8.67C50.01 3.86 47.15.1 44.7.48c-2.11.33-3.2 3.61-2.99 7.71.02.43-.46.69-.8.43-4.02-2.96-9.04-4.56-14.49-4.56-.14 0-.27.01-.4.01s-.27-.01-.4-.01c-5.45-.01-10.47 1.58-14.5 4.54a.503.503 0 0 1-.8-.44c.21-4.1-.87-7.38-2.97-7.71C4.88.06 2.01 3.81 1.22 8.82c-.58 3.67.02 6.99 1.31 8.67.34.45.68 1.36.46 1.96-.87 2.37-1.31 4.92-1.31 7.58 0 4.63 1.39 8.95 3.8 12.58.45.68 1.31.67 1.82.23-.14-1.3-.2-2.6-.25-3.89-.06-1.6-.08-3.19-.09-4.79-.01-1.59.01-3.19.03-4.78 0-.4.02-.79.02-1.18 0-.43.03-.86.09-1.28.11-.85.34-1.7.69-2.5.69-1.6 1.92-3.06 3.62-3.84.83-.39 1.8-.58 2.68-.58l2.38-.04 19.07.02 2.38.05c.88 0 1.85.19 2.68.58 1.69.78 2.92 2.24 3.61 3.84.35.8.57 1.65.68 2.5.06.43.08.85.08 1.28 0 .39.01.78.01 1.18.02 1.6.03 3.19.02 4.79-.01 1.59-.04 3.19-.1 4.79a56.86 56.86 0 0 1-.26 3.89c.5.45 1.37.46 1.82-.22 2.41-3.62 3.82-7.94 3.82-12.57 0-2.65-.44-5.21-1.3-7.58-.2-.62.14-1.53.48-1.97zm.12-7.22c-.03 4.7-1.91 6.7-1.91 6.7s.51-3.86.25-6.21l-1.38 1.4s.37-1.88-.07-5.13c-.24-1.8-1.7-4.84-1.65-4.83 2.16.45 4.79 3.68 4.76 8.07zM47.8 22.4c-.64-1.94-1.59-3.42-2.71-4.55-.28-.28-.57-.54-.88-.79-.6-.48-1.25-.89-1.91-1.22-1.66-.84-3.47-1.26-5.18-1.47-1.37-.17-2.68-.2-3.81-.2l-10.39-.01 7.82-2.93L25 9.66l5.66-1.81-5.24-1.77s1.33-.05 2.6-.07c.17-.01.35-.01.53-.01 1.94 0 3.73.26 5.37.71 1.09.3 2.12.69 3.08 1.15 1.45.69 2.76 1.53 3.94 2.48 3.69 2.95 5.4 5.97 6.2 8.24.2.57.34 1.09.44 1.56.2.93.23 1.62.23 1.99 0 .18-.01.27-.01.27z"
                    />
                  </svg>
                  <svg
                    v-else
                    xmlns="http://www.w3.org/2000/svg"
                    width="48"
                    height="66"
                    viewBox="0 0 48 66"
                  >
                    <path
                      d="M23.74 3.02c5.182 0 9.927 1.81 13.604 4.816-.43-4.077.75-7.496 2.78-7.812 2.166-.338 4.483 2.982 5.173 7.412.507 3.25-.02 6.18-1.164 7.668-.303.394-.604 1.202-.41 1.735.762 2.094 1.154 4.354 1.154 6.7 0 5.337-2.1 10.197-5.54 13.847v7.134c.013.69-.493 1.16-1.192 1.182H34.92v-3.3a.412.412 0 0 0-.41-.41h-.133a.412.412 0 0 0-.41.41v3.3h-4.4v-3.3a.412.412 0 0 0-.41-.41h-.133a.412.412 0 0 0-.41.41v3.3h-4.4v-3.3a.412.412 0 0 0-.41-.41h-.134a.412.412 0 0 0-.41.41v3.3h-4.4v-3.3a.412.412 0 0 0-.41-.41h-.134a.41.41 0 0 0-.41.41v3.3h-4.4v-3.3a.412.412 0 0 0-.41-.41h-.133a.412.412 0 0 0-.41.41v3.3h-3.33c-.65-.013-1.067-.583-1.078-1.186v-7.13c-3.44-3.65-5.54-8.51-5.54-13.845 0-2.338.454-4.57 1.148-6.68.25-.763-.204-1.434-.492-1.805-1.145-1.48-1.625-4.405-1.125-7.618.69-4.43 3.007-7.75 5.173-7.413 2.04.318 3.218 3.76 2.775 7.86C13.768 4.85 18.535 3.02 23.74 3.02zm10.507 28.292c3.17 0 5.743-3.59 5.743-8.016 0-4.427-2.572-8.017-5.743-8.017-3.17 0-5.742 3.59-5.742 8.016s2.57 8.016 5.742 8.016zm-21.037 0c3.17 0 5.742-3.59 5.742-8.016 0-4.427-2.57-8.017-5.742-8.017-3.17 0-5.743 3.59-5.743 8.016s2.572 8.016 5.743 8.016zm10.504 2.32l-1.018 1.765-1.02 1.765h4.076l-1.02-1.765-1.018-1.765z"
                      clip-rule="evenodd"
                      fill-rule="evenodd"
                    />
                    <path
                      d="M1.18 54.638a.698.698 0 0 1-.514-.21.698.698 0 0 1-.21-.514c0-.19.07-.36.21-.506.14-.146.312-.22.515-.22h5.167c.254 0 .474.058.658.173a.566.566 0 0 1 .276.515.8.8 0 0 1-.113.42l-4.862 6.9h4.327a.7.7 0 0 1 .515.21.7.7 0 0 1 .21.515c0 .19-.07.36-.21.505a.684.684 0 0 1-.515.22H1.028c-.267 0-.48-.067-.638-.2a.632.632 0 0 1-.238-.506c0-.153.044-.293.133-.42l4.842-6.882H1.18zm6.96 1.906c0-.47.088-.915.266-1.334.178-.42.426-.785.743-1.097.317-.31.683-.556 1.096-.733.413-.178.86-.267 1.344-.267.47 0 .915.088 1.334.267.42.177.785.422 1.096.733.312.312.56.677.744 1.097.184.42.276.864.276 1.334v1.373a.7.7 0 0 1-.21.515.7.7 0 0 1-.514.21H9.588v.648c0 .267.054.52.162.762.108.242.25.454.43.64.177.183.39.326.637.428.248.102.506.152.772.152a1.984 1.984 0 0 0 1.83-1.162l.018-.058c.05-.14.137-.25.257-.333a.706.706 0 0 1 .41-.125c.204 0 .375.073.515.22a.71.71 0 0 1 .21.504c0 .088-.02.177-.057.267l-.038.076a3.442 3.442 0 0 1-1.24 1.487c-.56.38-1.194.572-1.906.572a3.427 3.427 0 0 1-2.43-1 3.54 3.54 0 0 1-.745-1.098 3.272 3.272 0 0 1-.276-1.334v-2.746zm1.448.648h4.003v-.648c0-.267-.053-.52-.16-.763a2.21 2.21 0 0 0-.43-.637 1.854 1.854 0 0 0-.638-.43 2.017 2.017 0 0 0-.772-.152 1.99 1.99 0 0 0-1.85 1.22 1.948 1.948 0 0 0-.152.764v.648zm6.482-.648c0-.47.088-.915.267-1.334.178-.42.425-.785.743-1.097.318-.31.683-.556 1.096-.733a3.36 3.36 0 0 1 1.344-.267c.47 0 .915.088 1.334.267.42.177.785.422 1.097.733.312.312.56.677.744 1.097.184.42.277.864.277 1.334v1.373a.7.7 0 0 1-.21.515.7.7 0 0 1-.514.21h-4.728v.648c0 .267.054.52.162.762.108.242.25.454.43.64.177.183.39.326.638.428.248.102.505.152.772.152a1.984 1.984 0 0 0 1.83-1.162l.02-.058c.05-.14.135-.25.256-.333a.706.706 0 0 1 .41-.125c.203 0 .375.073.514.22a.71.71 0 0 1 .21.504c0 .088-.02.177-.057.267l-.038.076a3.44 3.44 0 0 1-1.24 1.487c-.558.38-1.193.572-1.905.572a3.427 3.427 0 0 1-2.43-1 3.55 3.55 0 0 1-.744-1.098 3.28 3.28 0 0 1-.277-1.334v-2.746zm1.448.648h4.004v-.648c0-.267-.055-.52-.162-.763a2.212 2.212 0 0 0-.43-.637 1.852 1.852 0 0 0-.638-.43 2.017 2.017 0 0 0-.772-.152 1.988 1.988 0 0 0-1.85 1.22 1.948 1.948 0 0 0-.152.764v.648zm5.777 4.728a.7.7 0 0 1 .21-.515c.14-.14.31-.21.514-.21.19 0 .358.07.504.21.146.14.22.312.22.515 0 .204-.07.375-.21.515a.7.7 0 0 1-.515.21.71.71 0 0 1-.507-.21.685.685 0 0 1-.218-.515zm7.225-11.362a.7.7 0 0 1 .21-.515.7.7 0 0 1 .514-.21c.19 0 .36.07.505.21.145.14.22.312.22.515v8.73c0 .472-.094.916-.278 1.335-.184.42-.432.786-.743 1.097a3.422 3.422 0 0 1-2.432 1c-.483 0-.93-.088-1.344-.266a3.567 3.567 0 0 1-1.096-.734 3.378 3.378 0 0 1-1.01-2.43v-2.746c0-.47.092-.915.276-1.335.184-.42.432-.786.744-1.097a3.422 3.422 0 0 1 2.43-1c.37 0 .72.057 1.058.17.337.115.652.274.944.477v-3.202zm-4.004 8.73a1.987 1.987 0 0 0 2 1.982c.268.002.525-.05.773-.15a1.85 1.85 0 0 0 .638-.43c.178-.184.32-.397.43-.638.107-.24.16-.496.16-.763v-2.746c0-.267-.05-.52-.15-.763a1.98 1.98 0 0 0-1.07-1.066 1.994 1.994 0 0 0-.78-.153c-.268 0-.525.052-.772.154-.248.102-.46.244-.64.43-.177.183-.32.396-.428.637a1.85 1.85 0 0 0-.162.764v2.745zm6.634-2.744a3.383 3.383 0 0 1 1.01-2.43c.318-.312.684-.557 1.097-.734a3.36 3.36 0 0 1 1.344-.267 3.424 3.424 0 0 1 2.43 1c.313.312.56.677.745 1.097.185.42.277.864.277 1.334v2.746c0 .47-.09.915-.267 1.334-.178.42-.426.785-.744 1.096-.316.312-.685.557-1.104.735a3.39 3.39 0 0 1-1.335.267 3.427 3.427 0 0 1-2.43-1 3.54 3.54 0 0 1-.743-1.098 3.28 3.28 0 0 1-.276-1.334v-2.746zm1.45 2.745c0 .266.053.52.162.762.107.24.25.454.428.638.178.185.39.327.64.43.247.1.504.152.77.152a1.983 1.983 0 0 0 1.85-1.22c.102-.242.152-.497.152-.764v-2.746c0-.267-.054-.52-.162-.763a2.203 2.203 0 0 0-.43-.637 1.856 1.856 0 0 0-.637-.43 2.017 2.017 0 0 0-.772-.152 1.986 1.986 0 0 0-2 1.984v2.745zm6.347-2.746c0-.47.09-.915.268-1.334.177-.42.425-.785.743-1.097.318-.31.683-.556 1.096-.733a3.36 3.36 0 0 1 1.344-.267c.47 0 .915.088 1.334.267.42.177.785.422 1.096.733.312.312.56.677.744 1.097.184.42.276.864.276 1.334v6.025c0 .47-.092.913-.276 1.333A3.56 3.56 0 0 1 46.828 65a3.42 3.42 0 0 1-1.096.733c-.42.178-.864.267-1.334.267a.7.7 0 0 1-.515-.21.698.698 0 0 1-.21-.515c0-.203.07-.374.21-.514a.7.7 0 0 1 .515-.21c.267 0 .524-.05.772-.152a1.85 1.85 0 0 0 .638-.43c.178-.183.32-.396.43-.637.107-.24.16-.494.16-.76v-.478c-.596.42-1.263.63-2 .63-.47 0-.915-.09-1.335-.268a3.42 3.42 0 0 1-1.096-.734 3.533 3.533 0 0 1-.743-1.097 3.28 3.28 0 0 1-.277-1.334v-2.746zm1.45 2.745c0 .266.053.52.16.762.11.24.252.454.43.638.178.185.39.327.64.43a2.055 2.055 0 0 0 1.534.01c.24-.096.45-.23.628-.4.177-.173.32-.373.428-.602.108-.23.17-.476.18-.744v-2.84c0-.267-.053-.52-.16-.763a2.22 2.22 0 0 0-.43-.637 1.856 1.856 0 0 0-.638-.43 2.018 2.018 0 0 0-.772-.152 1.99 1.99 0 0 0-1.85 1.22 1.947 1.947 0 0 0-.152.764v2.745z"
                    />
                  </svg>
                  <span>| OMS</span>
                </h1>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="24">
                <h4 class="text-center">Create an account to manage orders:</h4>
              </el-col>
            </el-row>
            <el-row>
              <div v-if="error" class="alert alert-danger">
                <p>{{ error }}</p>
              </div>
              <el-form
                ref="credentials"
                :model="credentials"
                :rules="credentialsRules"
                class="login-form"
              >
                <el-row :gutter="10">
                  <el-col :span="24">
                    <el-form-item prop="email">
                      <el-input
                        v-model="credentials.email"
                        placeholder="Email"
                        @keyup.native.enter="submitForm('credentials')"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="10">
                  <el-col :span="12">
                    <el-form-item prop="firstName">
                      <el-input
                        v-model="credentials.firstName"
                        placeholder="First Name"
                        @keyup.native.enter="submitForm('credentials')"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item prop="lastName">
                      <el-input
                        v-model="credentials.lastName"
                        placeholder="Last Name"
                        @keyup.native.enter="submitForm('credentials')"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="10">
                  <el-col :span="12">
                    <el-form-item prop="password">
                      <el-input
                        v-model="credentials.password"
                        type="password"
                        placeholder="Password"
                        @keyup.native.enter="submitForm('credentials')"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item prop="confirm_password">
                      <el-input
                        v-model="credentials.confirm_password"
                        type="password"
                        placeholder="Confirm Password"
                        @keyup.native.enter="submitForm('credentials')"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-button
                  type="success"
                  class="btn-block"
                  @click.prevent="submitForm('credentials')"
                >Create Account</el-button>
              </el-form>
            </el-row>
            <el-row>
              <router-link
                to="/login"
                class="text-center btn-block"
              >Already have an account? Click here.</router-link>
            </el-row>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <div class="pattern-bg"></div>
  </div>
</template>

<script>
import Auth from "@/auth/index";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      credentials: {
        email: "",
        firstName: "",
        lastName: "",
        password: "",
        confirm_password: ""
      },
      error: "",
      credentialsRules: {
        email: [
          { required: true, message: "Must be a valid email", trigger: "blur" },
          { type: "email", message: "Must be a valid email", trigger: "blur" }
        ],
        firstName: [
          {
            required: true,
            message: "Please input your first name",
            trigger: "blur"
          }
        ],
        lastName: [
          {
            required: true,
            message: "Please input your last name",
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            message: "Please input a password",
            trigger: "blur"
          },
          { min: 4, message: "Length should be higher than 3", trigger: "blur" }
        ],
        confirm_password: [
          {
            required: true,
            message: "Please confirm the password",
            trigger: "blur"
          },
          { min: 4, message: "Length should be higher than 3", trigger: "blur" }
        ]
      }
    };
  },
  computed: {
    ...mapGetters({
      isZeenow: "isZeenow"
    })
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.credentials.password === this.credentials.confirm_password) {
            const credentials = {
              email: this.credentials.email,
              firstName: this.credentials.firstName,
              lastName: this.credentials.lastName,
              password: this.credentials.password,
              confirm_password: this.credentials.confirm_password
            };
            return Auth.register(this, credentials, true);
          }
          return this.$message.warning(
            "Password and Confirm Password must be equal"
          );
        }
        return false;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.center-block {
  display: inline-block;
  margin: 0 auto;
  width: 100%;
}
.signup-component {
  .signup-card {
    padding: 3em 4em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SignupPage.vue